import { Injectable } from '@angular/core';
import { PluginListenerHandle } from '@capacitor/core';
import { ConnectionStatus, Network } from '@capacitor/network';

@Injectable({
  providedIn: 'root'
})
export class NetworkConnectionService {

  public hasNetworkConnection = true;
  public networkStatusListener: PluginListenerHandle | null = null;

  public async initialize() {
    const status = await this.getNetworkStatus();
    this.logStatus(status);
    this.hasNetworkConnection = status.connected;

    this.networkStatusListener = await this.addNetworkListener(changedStatus => {
      this.logStatus(changedStatus);
      this.hasNetworkConnection = changedStatus.connected;
    });
  }

  /**
   * Thin seams around the Capacitor Network plugin. The plugin is a
   * `registerPlugin` Proxy whose methods cannot be replaced with `spyOn`,
   * so exposing them here lets tests stub the service's own methods instead.
   */
  protected getNetworkStatus(): Promise<ConnectionStatus> {
    return Network.getStatus();
  }

  protected addNetworkListener(
    callback: (status: ConnectionStatus) => void
  ): Promise<PluginListenerHandle> {
    return Network.addListener('networkStatusChange', callback);
  }

  private logStatus(status: ConnectionStatus): void {
    console.log(`[Network] ${status.connected ? 'Connected' : 'Disconnected'} (${status.connectionType})`);
  }

}
